import type React from "react";
import {
  Alert as ShadcnAlert,
  AlertTitle as ShadcnAlertTitle,
  AlertDescription as ShadcnAlertDescription,
  AlertAction as ShadcnAlertAction,
} from "src/shadcn/components/alert";

const Alert = (props: React.ComponentProps<typeof ShadcnAlert>) => (
  <ShadcnAlert {...props} />
);

const AlertTitle = (props: React.ComponentProps<typeof ShadcnAlertTitle>) => (
  <ShadcnAlertTitle {...props} />
);

const AlertDescription = (
  props: React.ComponentProps<typeof ShadcnAlertDescription>
) => <ShadcnAlertDescription {...props} />;

const AlertAction = (props: React.ComponentProps<typeof ShadcnAlertAction>) => (
  <ShadcnAlertAction {...props} />
);

export { Alert, AlertTitle, AlertDescription, AlertAction };
